import { render, staticRenderFns } from "./DesignatedAdd.vue?vue&type=template&id=cf5317a0"
import script from "./DesignatedAdd.vue?vue&type=script&lang=js"
export * from "./DesignatedAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports